import styled from 'styled-components';
import { Button, SimpleModal } from '../../atoms';

export const ChangeButton = styled(Button)`
  align-self: end;
`;

export const ChangeModal = styled(SimpleModal)`
  > .ant-modal-content {
    padding: 20px;
  }
`;

export const CloseButton = styled(Button)`
  padding: 12px 12px;
`;
